import { TYPE } from 'vue-toastification'

import SuccessIcon from '@/components/Toast/Success.vue'
import ErrorIcon from '@/components/Toast/Error.vue'
import WarningIcon from '@/components/Toast/Warning.vue'
import InfoIcon from '@/components/Toast/Info.vue'

export default function ({ $toast, $helpers }) {
    const rtl = !!$helpers.isRtl()

    const options = {
        toastDefaults: {
            // ToastOptions object for each type of toast
            [TYPE.DEFAULT]: {
                icon: InfoIcon,
                rtl
            },
            [TYPE.ERROR]: {
                icon: ErrorIcon,
                rtl
            },
            [TYPE.SUCCESS]: {
                icon: SuccessIcon,
                rtl
            },
            [TYPE.INFO]: {
                icon: InfoIcon,
                rtl
            },
            [TYPE.WARNING]: {
                icon: WarningIcon,
                rtl
            }
        }
    }

    $toast.updateDefaults(options)
}
